import { gql } from '@apollo/client';
import { TRANSLATED_STRING_FIELDS } from '@assets/i18n/config';

export const CREATE_MODEL_PORTFOLIO = gql`
  mutation createModelPortfolio($input: CreateModelPortfolioInput!) {
    createModelPortfolio(input: $input) {
      modelPortfolio {
        id
        name
        state
        settlementDays
        suggestedMinScore
        suggestedMaxScore
        suggestable
        theme {
          core
          description
          iconKey
          id
          key
          name
          state
          translatedDescription { ${TRANSLATED_STRING_FIELDS} }
          translatedName { ${TRANSLATED_STRING_FIELDS} }
          translatedShortDescription { ${TRANSLATED_STRING_FIELDS} }
        }
        portfolioTemplate {
          assetClassBranches {
            assetClass {
              description
              id
              includeCash
              key
              name
              state
              translatedDescription { ${TRANSLATED_STRING_FIELDS} }
              translatedName { ${TRANSLATED_STRING_FIELDS} }
            }
            id
            targetPercentage
          }
          createdAt
          id
          name
          state
          translatedName { ${TRANSLATED_STRING_FIELDS} }
          translatedTemplateDescription { ${TRANSLATED_STRING_FIELDS} }
          updatedAt
        }
        priceHistoryUrl
        portfolioDisclaimer
        translatedPortfolioDescription { ${TRANSLATED_STRING_FIELDS} }
        translatedPortfolioDisclaimer { ${TRANSLATED_STRING_FIELDS} }
        translatedUrl { ${TRANSLATED_STRING_FIELDS} }
        translatedThemeName { ${TRANSLATED_STRING_FIELDS} }
        translatedName { ${TRANSLATED_STRING_FIELDS} }
        translatedLiquidity { ${TRANSLATED_STRING_FIELDS} }
        translatedInvestmentObjective { ${TRANSLATED_STRING_FIELDS} }
        tradeable
        targetAllocations {
          max
          min
          secondaryAssetClass {
            id
            key
            name
          }
        }
        forecastedStandardDeviation
        forecastedRateOfReturn
        strategy
        assetClassLevel
        assetClassBranches {
          id
          targetPercentage
          assetClass {
            id
            name
            key
            translatedName { ${TRANSLATED_STRING_FIELDS} }
          }
        }
        children {
          id
          isCashEquivalent
          percentage
          effectivePercentage
          taxRank
          assetClass {
            id
            name
            key
            translatedName { ${TRANSLATED_STRING_FIELDS} }
          }
          financialProduct {
            id
            name
            primaryAssetClass {
              id
              key
              name
              translatedName { ${TRANSLATED_STRING_FIELDS} }
              description
              state
            }
            secondaryAssetClass {
              id
              translatedName { ${TRANSLATED_STRING_FIELDS} }
            }
            tertiaryAssetClass {
              id
              translatedName { ${TRANSLATED_STRING_FIELDS} }
            }
          }
        }
      }
    }
  }
`;

export const UPDATE_MODEL_PORTFOLIO = gql`
  mutation updateModelPortfolio($input: UpdateModelPortfolioInput!) {
    updateModelPortfolio(input: $input) {
      modelPortfolio {
        id
        name
        state
        settlementDays
        suggestedMinScore
        suggestedMaxScore
        suggestable
        theme {
          core
          description
          iconKey
          id
          key
          name
          state
          translatedDescription { ${TRANSLATED_STRING_FIELDS} }
          translatedName { ${TRANSLATED_STRING_FIELDS} }
          translatedShortDescription { ${TRANSLATED_STRING_FIELDS} }
        }
        portfolioTemplate {
          assetClassBranches {
            assetClass {
              description
              id
              includeCash
              key
              name
              state
              translatedDescription { ${TRANSLATED_STRING_FIELDS} }
              translatedName { ${TRANSLATED_STRING_FIELDS} }
            }
            id
            targetPercentage
          }
          createdAt
          id
          name
          state
          translatedName { ${TRANSLATED_STRING_FIELDS} }
          translatedTemplateDescription { ${TRANSLATED_STRING_FIELDS} }
          updatedAt
        }
        priceHistoryUrl
        portfolioDisclaimer
        translatedPortfolioDescription { ${TRANSLATED_STRING_FIELDS} }
        translatedPortfolioDisclaimer { ${TRANSLATED_STRING_FIELDS} }
        translatedUrl { ${TRANSLATED_STRING_FIELDS} }
        translatedThemeName { ${TRANSLATED_STRING_FIELDS} }
        translatedName { ${TRANSLATED_STRING_FIELDS} }
        translatedLiquidity { ${TRANSLATED_STRING_FIELDS} }
        translatedInvestmentObjective { ${TRANSLATED_STRING_FIELDS} }
        tradeable
        targetAllocations {
          max
          min
          secondaryAssetClass {
            id
            key
            name
          }
        }
        forecastedStandardDeviation
        forecastedRateOfReturn
        strategy
        assetClassLevel
        assetClassBranches {
          id
          targetPercentage
          assetClass {
            id
            name
            key
            translatedName { ${TRANSLATED_STRING_FIELDS} }
          }
        }
        children {
          id
          isCashEquivalent
          percentage
          effectivePercentage
          taxRank
          assetClass {
            id
            name
            key
            translatedName { ${TRANSLATED_STRING_FIELDS} }
          }
          financialProduct {
            id
            name
            primaryAssetClass {
              id
              key
              name
              translatedName { ${TRANSLATED_STRING_FIELDS} }
              description
              state
            }
            secondaryAssetClass {
              id
              translatedName { ${TRANSLATED_STRING_FIELDS} }
            }
            tertiaryAssetClass {
              id
              translatedName { ${TRANSLATED_STRING_FIELDS} }
            }
          }
        }
      }
    }
  }
`;

export const TRANSITION_MODEL_PORTFOLIO = gql`
  mutation transitionModelPortfolio($input: TransitionModelPortfolioInput!) {
    transitionModelPortfolio(input: $input) {
      modelPortfolio {
        id
        state
      }
    }
  }
`;

export const FETCH_MODEL_PORTFOLIO = gql`
  query fetchModelPortfolio($input: FetchModelPortfolioInput!) {
    fetchModelPortfolio(input: $input) {
      modelPortfolio {
        id
        assignable
        organization {
          id
          translatedName { ${TRANSLATED_STRING_FIELDS} }
        }
        translatedName { ${TRANSLATED_STRING_FIELDS} }
        translatedInvestmentObjective { ${TRANSLATED_STRING_FIELDS} }
        translatedLiquidity { ${TRANSLATED_STRING_FIELDS} }
        translatedPortfolioDescription { ${TRANSLATED_STRING_FIELDS} }
        translatedPortfolioDisclaimer { ${TRANSLATED_STRING_FIELDS} }
        theme {
          id
          name
        }
        children {
          id
          percentage
          effectivePercentage
          isCashEquivalent
          taxRank
          assetClass {
            id
            name
            key
            translatedName { ${TRANSLATED_STRING_FIELDS} }
          }
          financialProduct {
            id
            isCash
            ticker
            name
            translatedName { ${TRANSLATED_STRING_FIELDS} }
            primaryAssetClass{
              id
              name
              translatedName { ${TRANSLATED_STRING_FIELDS} }
            }
            secondaryAssetClass {
              id
              name
              translatedName { ${TRANSLATED_STRING_FIELDS} }
            }
            tertiaryAssetClass {
              id
              name
              translatedName { ${TRANSLATED_STRING_FIELDS} }
            }
            taxRank
          }
        }
        exchange
        forecastedRateOfReturn
        forecastedStandardDeviation
        lowThresholdScore
        reasonForUpdate
        riskProfileName { ${TRANSLATED_STRING_FIELDS} }
        riskReturnLevel
        state
        assignedCount
        driftCalculationMethod
        driftTolerancePercent
        suggestable
        zeroPercentCash
        strategy
        assetClassLevel
        assetClassBranches {
          id
          targetPercentage
          assetClass {
            id
            name
            key
            translatedName { ${TRANSLATED_STRING_FIELDS} }
          }
        }
        suggestedMaxScore
        suggestedMinScore
        translatedUrl { ${TRANSLATED_STRING_FIELDS} }
        targetAllocations {
          min
          max
          secondaryAssetClass {
            id
            translatedName { ${TRANSLATED_STRING_FIELDS} }
          }
        }
      }
    }
  }
`;

export const FETCH_CASH_FINANCIAL_PRODUCT = gql`
  query fetchCashFinancialProduct {
    fetchCashFinancialProduct {
      financialProduct {
        id
        name
        isCash
        translatedName { ${TRANSLATED_STRING_FIELDS} }
        primaryAssetClass {
          id
          key
          name
          translatedName { ${TRANSLATED_STRING_FIELDS} }
        }
        secondaryAssetClass {
          id
          key
          name
          translatedName { ${TRANSLATED_STRING_FIELDS} }
        }
        tertiaryAssetClass {
          id
          key
          name
          translatedName { ${TRANSLATED_STRING_FIELDS} }
        }
      }
    }
  }
`;

export const FETCH_MODEL_PORTFOLIOS = gql`
  query fetchModelPortfolios($input: FetchModelPortfoliosInput!) {
    fetchModelPortfolios(input: $input) {
      modelPortfolios {
        id
        name
        state
      }
    }
  }
`;

export const WORKFLOW_COMPLETION = () => `#graphql
  workflowCompletion {
    id
    objectId
    externalObjectId
    objectType
    context
    workflow {
      id
      complex
      settings {
        displayCloseButton
      }
      name { ${TRANSLATED_STRING_FIELDS} }
      steps {
        id
        name { ${TRANSLATED_STRING_FIELDS} }
        subSteps { id type options }
      }
    }
    organization {
      id
    }
    currentStep {
      id
      name { ${TRANSLATED_STRING_FIELDS} }
      subSteps { id type }
    }
    currentSubStep {
      id
      options
      type
      canGoBack
      skippable
      rolesCompleteableBy { id }
    }
  }
`;

export const NEXT_STEP = () => gql`
  mutation nextSubStep($input: NextSubStepInput!) {
    nextSubStep(input: $input) {
      ${WORKFLOW_COMPLETION()}
    }
  }
`;

export const PREV_STEP = () => gql`
  mutation previousSubStep($input: PreviousSubStepInput!) {
    previousSubStep(input: $input) {
      ${WORKFLOW_COMPLETION()}
    }
  }
`;

export const GO_TO_STEP = () => gql`
  mutation goToSubStep($input: GoToSubStepInput!) {
    goToSubStep(input: $input) {
      ${WORKFLOW_COMPLETION()}
    }
  }
`;

export const UPDATE_WORKFLOW_COMPLETION = () => gql`
  mutation updateWorkflowCompletion($input: UpdateWorkflowCompletionInput!) {
    updateWorkflowCompletion(input: $input) {
      ${WORKFLOW_COMPLETION()}
    }
  }
`;

export const CREATE_WORKFLOW_COMPLETION = () => gql`
  mutation createWorkflowCompletion($input: CreateWorkflowCompletionInput!) {
    createWorkflowCompletion(input: $input) {
      ${WORKFLOW_COMPLETION()}
    }
  }
`;
